import { DISCORD, INSTAGRAM, TWITTER } from "constants/links";

import XIcon from "@mui/icons-material/X";
import { Link, Stack } from "@mui/material";
import { ReactComponent as Instagram } from "assets/instagram.svg";
import { Discord } from "components/icons";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";

const Socials = () => {
  const { colors } = useMUIThemeModeContext();

  return (
    <Stack direction="row" spacing={{ xs: 1, md: 2 }}>
      <Link href={DISCORD} target="_blank" rel="noreferrer" sx={{ display: "flex" }}>
        <Discord sx={{ color: "#5865F2" }} />
      </Link>
      <Link href={TWITTER} target="_blank" rel="noreferrer" sx={{ display: "flex" }}>
        <XIcon sx={{ color: colors.black }} />
      </Link>
      <Link href={INSTAGRAM} target="_blank" rel="noreferrer" sx={{ display: "flex" }}>
        <Instagram style={{ width: 24, height: 24 }} />
      </Link>
    </Stack>
  );
};

export default Socials;
